import { FC, useId } from 'react';
import { Box, Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles<any>()({
  label: {
    fontFamily: 'DM Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#B6B6B6',
  },
  warning: {
    fontFamily: 'DM Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#FF0000',
    whiteSpace: 'pre-wrap',
    wordWrap: 'normal',
  },
  value: {
    fontFamily: 'DM Sans',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: '#4B4B4B',
    whiteSpace: 'pre-wrap',
    wordWrap: 'normal',
  },
});

type LabelValueListProps = {
  properties: Array<ILabelValueProp>;
};

export interface ILabelValueProp {
  label: string;
  value: any;
  title?: any | null;
  isWarning?: boolean;
}

export const LabelValueList: FC<LabelValueListProps> = ({ properties }) => {
  const { classes } = useStyles(null);

  // We need it here to keep list line key unique even if few lists have same label inside
  const instanceId = useId();

  return (
    <Box display="flex" flexDirection="column" gap={1} width="100%">
      {properties.map((prop: ILabelValueProp) => (
        <Box
          key={`${`value-label-item-${instanceId}-${prop.label
            .toLowerCase()
            .replace(' ', '-')}`}`}
          alignItems="center"
          display="flex"
        >
          <Box
            className={classes.label}
            display="flex"
            title={prop.title || ''}
            width={0.4}
          >
            {prop.label}
          </Box>
          <Box
            className={prop.isWarning ? classes.warning : classes.value}
            width={0.6}
          >
            {prop.value !== null ? prop.value : '--'}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export const LabelValueListVertical: FC<LabelValueListProps> = ({
  properties,
}) => {
  const { classes } = useStyles(null);

  // We need it here to keep list line key unique even if few lists have same label inside
  const instanceId = useId();

  return (
    <Grid container>
      {properties.map((prop: ILabelValueProp) => (
        <Grid
          key={`${`value-label-item-${instanceId}-${prop.label
            .toLowerCase()
            .replace(' ', '-')}`}`}
          item
          sx={{ paddingRight: '0px' }}
          xs={12}
        >
          <Box display="flex" flexDirection="column" mb={0.8}>
            <Box className={classes.label} display="flex">
              {prop.label}
            </Box>
            <Box
              className={
                prop.isWarning && prop.isWarning === true
                  ? classes.warning
                  : classes.value
              }
              display="flex"
            >
              {prop.value !== null && prop.value !== '' ? prop.value : '--'}
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};
